import gql from 'graphql-tag'
import { standardOrder } from '../fragments'

const createStandardOrderMutation = gql`
mutation CA_Mutation_createStandardOrderValues($required: StandardOrderValuesRequired!, $fields: StandardOrderValuesInput) {
	cashAssist {
		createStandardOrderValues(required: $required, fields: $fields) {
			...standardOrder
		}
	}
}
${standardOrder}`

export default createStandardOrderMutation
